import React, { useState } from "react";
import { useUser } from "./UserContext";
import TermsAndConditions from "./TermsAndConditions";
import { Account } from "appwrite";
import client from "./appwriteConfig";
import "./css/TermsModal.css";
import { ClipLoader } from "react-spinners";

const TermsModal = () => {
  const { setTermsAccepted } = useUser();
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleAccept = async () => {
    if (!checked || loading) return;
    setLoading(true); // show spinner
    try {
      const account = new Account(client);
      const currentPrefs = await account.getPrefs();
      const updatedPrefs = {
        ...currentPrefs,
        termsAccepted: true,
      };
      await account.updatePrefs(updatedPrefs);
      setTermsAccepted(true);
    } catch (err) {
      console.error("❌ Failed to accept terms:", err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="terms-modal-overlay">
      <div className="terms-modal-box">
        <div className="terms-modal-scrollable">
          <TermsAndConditions />
        </div>
        <div className="terms-modal-footer">
          <label className="terms-modal-checkbox">
            <input
              type="checkbox"
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
            />
            <div className="i-agree">I agree to the Terms & Conditions</div>
          </label>
          <button
            className="terms-modal-button"
            onClick={handleAccept}
            disabled={!checked || loading}
          >
            {loading ? (
              <ClipLoader size={18} color="#fff" />
            ) : (
              "Accept and Continue"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
